import React from 'react'
import {Card, CardHeader, Table} from "reactstrap";
import {Container, Row, Col, Visible} from 'react-grid-system';
import {setConfiguration} from 'react-grid-system';
// Strings
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import dateHelpers from "../../helpers/DateHelper";
import PlayCard from "./PlayCard";
import Button from "reactstrap/es/Button";
import MyPosButtonsController from "./MyPosButtonsController";
import OneOnOneButtonsController from "./OneOnOneButtonsController";
import {cards} from "./playCardsInit";

const propTypes = {};

export default class PlayBoardContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                myPosition: "UTG",
                potType: "",
                lastRaiserPos: "",
                lastRaiseCalls: "",
                oppsLeft: "",
                deadCalls: "",
                deadRaises: "",
                or: false
            },
            subscriptions: null,
            isLoading: false,
        };
    }

    updateFilters = this.updateFilters.bind(this)
    batchUpdateFilters = this.batchUpdateFilters.bind(this)
    toggleOR = this.toggleOR.bind(this)

    toggleOR() {
        let filters = this.state.filters;
        filters.or = !filters.or
        this.setState({filters: filters})
    }

    resetFilters() {
        let filters = this.state.filters
        Object.keys(filters).forEach((key) => {
                if (key != "myPosition" && key != "or") {
                    filters[key] = null
                }
            }
        )

        return filters
    }

    batchUpdateFilters(newFilters, clearAll = false) {
        let filters = this.resetFilters()
        Object.keys(newFilters).forEach((newFilterKey) => {
            filters[newFilterKey] = newFilters[newFilterKey]
        })

        this.setState({filters: filters})
    }

    updateFilters(newFilter) {
        let newFilterKey = Object.keys(newFilter)[0]
        let newFilterValue = Object.values(newFilter)[0]

        let filters = this.resetFilters()
        filters[newFilterKey] = newFilterValue
        filters["or"] = false

        this.setState({filters: filters})
    }

    componentDidMount() {
        this.getData()
        setConfiguration({gridColumns: 14});
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    render() {

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>

                    {/*<p>*/}
                    {/*    <span>Your current screen class is </span>*/}
                    {/*    <Visible xs><strong>xs</strong></Visible>*/}
                    {/*    <Visible sm><strong>sm</strong></Visible>*/}
                    {/*    <Visible md><strong>md</strong></Visible>*/}
                    {/*    <Visible lg><strong>lg</strong></Visible>*/}
                    {/*    <Visible xl><strong>xl</strong></Visible>*/}
                    {/*    <Visible xxl><strong>xxl</strong></Visible>*/}
                    {/*    <span>.</span>*/}
                    {/*</p>*/}

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Card className="bg-default shadow">
                        <Container>
                            <Row>
                                <Col xs={14} sm={14} lg={7} xl={7} xxl={6}>
                                    <Row>
                                        <Container>
                                            {this.renderCards()}
                                        </Container>
                                    </Row>
                                </Col>
                                <Col xs={14} sm={14} lg={7} xl={7} xxl={7} style={{marginTop: "10px"}}>
                                    <MyPosButtonsController
                                        toggleOR={this.toggleOR} updateFilters={this.updateFilters}
                                        filters={this.state.filters}/>
                                    <OneOnOneButtonsController
                                        filters={this.state.filters}
                                        updateFilters={this.batchUpdateFilters}/>

                                    <hr className="my-4" style={{backgroundColor: "white", color: "white"}}/>
                                    <div className="text-muted" style={{marginTop: "20px"}}>
                                        <small
                                            className="text-success">FILTERS: {JSON.stringify(this.state.filters)}</small>
                                    </div>
                                </Col>

                            </Row>
                        </Container>
                    </Card>
                </>
            </LoadingOverlay>
        )
    }

    renderCards() {
        return (
            <Row style={{marginBottom: "20px"}}>
                {cards.map((card, index) => {
                    return (
                        <PlayCard key={card.l} style={{width: "100%"}} cardData={card}/>
                    )
                })}
            </Row>
        )
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-id":
                this.setState({userId: newValue});
                break;
            case "input-last":
                this.setState({numberOfEvents: newValue});
                break;
            default:
                break;
        }
    }

    renderReport() {
        return <Col lg="12">
            <Card>
                <Table
                    className="align-items-center table-light table-flush mt-2"
                    responsive
                >
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">User ID</th>
                        <th scope="col">User NAME</th>
                        <th scope="col">title</th>
                        <th scope="col">expires</th>
                        <th scope="col">type</th>
                    </tr>
                    </thead>
                </Table>
            </Card>
        </Col>
    }

    getData() {

        if (this.state.searchValue !== null) {
            this.setState({isLoading: true});
            reportApiService.admin_subscriptions()
                .then(res => {
                    this.setState({
                        isLoading: false,
                        subscriptions: res
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    onUserIdSelected(e, user_id) {
        e.preventDefault();
        this.setState({userId: user_id})
    }

    subscriptionsType(subscription) {
        if (!subscription.expires_at) return "Android"
        else if (subscription.name.includes("eur") || subscription.name.includes("rub") || subscription.name.includes("usd") || subscription.name.includes("uah")) return "Web"
        else return "iOS"
    }
}

